import Immutable from "immutable";
import { mapArrayToEntity } from "lib/data";

import * as common from "lib/appserver/entityHeaders/common";

const School = new Immutable.Record({
  ...common.defaultProperties,
  name: undefined,
  logoFileName: undefined,
  phoneNumber: undefined,
  emailAddress: undefined,
  websiteURL: undefined,
  repliesEnabled: undefined,
  timezoneOffset: undefined,
  serverId: undefined,
  classicId: undefined,
  neoId: undefined
}, "School");
export default School;

School.fromAppserver = function buildSchool(rawSchool) {
  return School({
    name: rawSchool.name,
    logoFileName: rawSchool.logo_file_name,
    phoneNumber: rawSchool.phone_number,
    emailAddress: rawSchool.email_address,
    websiteURL: rawSchool.website_url,
    repliesEnabled: rawSchool.replies_enabled === "Y",
    timezoneOffset: rawSchool.timezone_offset,
    serverId: rawSchool.appserver_server_id,
    classicId: rawSchool.classic_id,
    neoId: null, // Defaults to null - not passed as data from AppServer
    ...common.appserverAdapter(rawSchool)
  });
}

School.fromAppserverValueList = function buildSchool(valueList) {
  if (valueList.length < 12) { // Value for "classic_id" is only passed on data originating from Neo
    valueList.push(null);
  }
  const rawSchool = mapArrayToEntity([
    "appserver_server_hostname",
    "appserver_server_id",
    "appserver_remote_school_id",
    "appserver_remote_entity_id",
    "name",
    "logo_file_name",
    "phone_number",
    "website_url",
    "email_address",
    "replies_enabled",
    "timezone_offset",
    "classic_id"
  ], valueList);
  // special case for schools, their id is their school id
  rawSchool.id = rawSchool.appserver_remote_school_id;
  return School.fromAppserver(rawSchool);
}



// WEBPACK FOOTER //
// ./src/state/teachers/entities/School.js